import React from 'react'
import { toast } from 'react-toastify'

interface Props {
  bot: any
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
  closeDeleteModal: () => void
  fetchAllBots: () => void
}

const InstagramDeleteModal: React.FC<Props> = ({
  bot,
  setIsLoading,
  closeDeleteModal,
  fetchAllBots
}) => {
  const handleDelete = async () => {
    const token = localStorage.getItem('auth-token')
    if (!token) {
      console.error('No auth token found.')
      return
    }

    setIsLoading(true)

    try {
      const response = await fetch(
        `${process.env.REACT_APP_RESUME_PARSER_URL}/deleteInstagramApplication/${bot.id}`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      )

      if (!response.ok) {
        throw new Error(`Failed to delete bot: ${response.statusText}`)
      }

      toast.success('Bot deleted successfully')
      fetchAllBots()
      closeDeleteModal()
    } catch (error) {
      console.error('Error while deleting bot:', error)
      toast.error('Failed to delete bot. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      {/* <div className="modal-dialog modal-dialog-centered" role="document"> */}
      <div className='modal-content'>
        {/* Modal Header */}
        <div className='modal-header border-bottom-0 pb-2'>
          <div className='d-flex align-items-center'>
            <div className='bg-danger bg-opacity-10 rounded-circle p-2 me-3'>
              <svg
                width='24'
                height='24'
                fill='currentColor'
                className='text-danger'
                viewBox='0 0 16 16'
              >
                <path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />
                <path d='M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z' />
              </svg>
            </div>
            <h5 className='modal-title fw-bold text-dark mb-0' id='deleteModalLabel'>
              Confirm Deletion
            </h5>
          </div>
          <button
            type='button'
            className='btn-close'
            aria-label='Close'
            onClick={closeDeleteModal}
          ></button>
        </div>

        {/* Modal Body */}
        <div className='modal-body pt-2 pb-4'>
          <div className='text-center'>
            <p className='text-muted mb-3'>
              Are you sure you want to delete this bot? This action cannot be undone.
            </p>

            {bot?.name && (
              <div className='alert alert-light border border-danger border-opacity-25 mb-0'>
                <div className='d-flex align-items-center justify-content-center'>
                  <svg
                    width='16'
                    height='16'
                    fill='currentColor'
                    className='text-danger me-2'
                    viewBox='0 0 16 16'
                  >
                    <path d='M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4.414A2 2 0 0 0 3 11.586l-2 2V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                  </svg>
                  <strong className='text-danger'>{bot.name}</strong>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Modal Footer */}
        <div className='modal-footer border-top-0 pt-0'>
          <button
            type='button'
            className='btn btn-outline-secondary px-4'
            onClick={closeDeleteModal}
          >
            Cancel
          </button>
          <button type='button' className='btn btn-danger px-4 ms-2' onClick={handleDelete}>
            <svg width='16' height='16' fill='currentColor' className='me-2' viewBox='0 0 16 16'>
              <path d='M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z' />
              <path
                fillRule='evenodd'
                d='M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z'
              />
            </svg>
            Delete Bot
          </button>
        </div>
      </div>
      {/* </div> */}

      {/* Modal Backdrop */}
      {/* <div className="modal-backdrop fade show" onClick={closeDeleteModal}></div> */}
    </div>
  )
}

export default InstagramDeleteModal
